export default {
	bind: (el, binding) => {
		el.innerHTML = el.innerHTML.replace(/\r?\n/g, '<br />')
	}
}
